export default __webpack_public_path__ + "static/customer-c97e9b17cb112245e26207ab6242e4e3.jpg";